export default {
  created_date: 'added',
  updated_date: 'updated',
  videos_count: 'videos',
  clusters_count: 'clusters',
  participants_count: 'participants',
  status: 'status',
  creator: 'creator'
};
